module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-1950.dd143b23.svg";